export default __webpack_public_path__ + "static/media/0eceadb4da76040d6c98957be50a12d8.svg";